module.exports = __webpack_public_path__ + "b9b58b14985c1d680f9a31397f388a97.pdf";